export default __webpack_public_path__ + "media/images/logo/media/nihontv-2734bd53b4d57da92d19d1fad29fbbab.png";